export default __webpack_public_path__ + "static/media/ExpressingFeelings_07.884c1b40.png";